export type Action = () => void;

export type MonoAction<T> = (value: T) => void;

export type TransformAction<Tin, Tout> = (item: Tin) => Tout;

export type Predicate<T> = TransformAction<T, boolean>;

export type BiPredicate<T1, T2> = (one: T1, two: T2) => boolean;

export type BiMonoPredicate<T> = BiPredicate<T, T>;

export type Identity<T> = (item: T) => T;

export type ItemMutation<T> = {
    id: string;
    action: Identity<T>;
};

export type ItemsListTransaction<T> = {
    snapshot?: Array<T>;
    increment?: Array<T>;
    update?: Array<ItemMutation<T>>;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type PropertyContainerObjectType = { [key: string]: any };

export type ObjectPropType<T> = Extract<keyof T, string>;

/**
 * type to get type of property type of argument
 */
export type ObjectPropertyType<T, P extends keyof T> = T[P];

/**
 * to use fro referece full object
 */
export type FullObjectLiteral = 'ALL';

/**
 * Describe subset of props on argumet type
 */
export type ExtractionSelector<T> = keyof T | Array<keyof T> | FullObjectLiteral;

export const FULL_STATE: FullObjectLiteral = 'ALL';

/**
 * extract from array of string union type
 */
type LiteralType<T extends ReadonlyArray<unknown>> = T extends Array<infer R> ? R : never;

export type PickFromArray<T, K extends ReadonlyArray<keyof T>> = Pick<T, Extract<keyof T, LiteralType<K>>>;

/**
 * Change type for all props to string
 */
export type SerializedRecord<T> = Record<keyof T, string>;

/**
 * Change type for props to String to Original type function transformator
 */
export type PropertyParser<Subj, Target> = {
    [P in keyof Subj]: TransformAction<Target, Subj[P]>
};

/**
 * from property selector return agrument actual selection
 * from type {A: string, B: number} with selector 'A' return 'string'
 * from type {A: string, B: number, C: boolean} with selector ['A', 'C'] return {A: string, C: boolean}
 */
export type ExtractionResult<T, K extends ExtractionSelector<T>> =
    K extends FullObjectLiteral ? T :
        K extends Array<keyof T> ? PickFromArray<T, K> :
            ObjectPropertyType<T, Exclude<K, FullObjectLiteral | Array<keyof T>>>;
